import { RemoteGetAllSectors } from 'data/usecases';
import { makeApiUrlSectors } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllSectors = (): RemoteGetAllSectors => {
  return new RemoteGetAllSectors(makeApiUrlSectors(), makeAxiosHttpClient());
};
